import { DragDropModule } from "@angular/cdk/drag-drop";
import { ScrollingModule } from "@angular/cdk/scrolling";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MaterialModule } from "@app/material.module";
import { TranslateModule } from "@ngx-translate/core";
import { ColorPickerModule } from "ngx-color-picker";
import { SaveDashboardDialogComponent } from "./save-dashboard-dialog.component";

@NgModule({
	declarations: [SaveDashboardDialogComponent],
	imports: [
		CommonModule,
		MaterialModule,
		DragDropModule,
		ReactiveFormsModule,
		TranslateModule,
		FormsModule,
		ScrollingModule,
		ColorPickerModule,
	],
})
export class SaveDashboardDialogModule {}
